import { API } from "./HttpConfig";
import http from "./HttpUtil";
import * as Gateway from "./GatewayConfig";
// 获取网关参数
function getGatewayParams(params) {
  let obj = {};
  obj.appId = window.localStorage.getItem("appId_AI");
  obj.sessionId = window.localStorage.getItem("sessionId_AI")
    ? window.localStorage.getItem("sessionId_AI")
    : "";
  obj.timestamp = Date.parse(new Date());
  obj.bizReq = JSON.stringify(params);
  if (window.localStorage.getItem("clientType_AI")) {
    obj.clientType = window.localStorage.getItem("clientType_AI");
  }
  return obj;
}

// 获取网关参数
function getGatewayParams_H5(method, params, appId) {
  let obj = {};
  obj.appId = appId || Gateway.appId;
  obj.signType = "NA";
  obj.sign = "";
  obj.version = "1.0";
  // 不传sessionId
  obj.timestamp = Date.parse(new Date());
  if (method) {
    obj.method = method;
  }
  obj.bizReq = JSON.stringify(params);
  if (window.localStorage.getItem("clientType_AI")) {
    obj.clientType = window.localStorage.getItem("clientType_AI");
  }
  return obj;
}

function getGatewayParams_H5_WITH_SESSION(method, params, appId, version) {
  let obj = {};
  obj.appId = appId || Gateway.appId;
  obj.signType = "NA";
  obj.sign = "";
  obj.version = version || "1.0";
  obj.sessionId = window.localStorage.getItem("sessionId")
    ? window.localStorage.getItem("sessionId")
    : "";
  obj.timestamp = Date.parse(new Date());
  obj.method = method;
  obj.bizReq = JSON.stringify(params);
  if (window.localStorage.getItem("clientType_AI")) {
    obj.clientType = window.localStorage.getItem("clientType_AI");
  }
  return obj;
}

// POST 直接调用AI网关
const POST = (method, params) => {
  let param = getGatewayParams(params);
  return http.post(method, param);
};

// POST2 调用文字转语音&语音转文字   "Content-Type": "multipart/form-data",
const POST2 = (method, formData) => {
  return http.post2(method, formData);
};

// POST_AUTH 调用前置授权登录等接口    apiPath    liuzhouGateway nantongGateway pinbaGateway fuzhuangGateway
const POST_AUTH = (method, params, apiPath, appId) => {
  let param = getGatewayParams_H5(method, params, appId);
  return http.post_auth(apiPath, param);
};

// 上面的 带sessionId
const POST_AUTH_WITH_SESSION = (method, params, apiPath, appId) => {
  let param = getGatewayParams_H5_WITH_SESSION(method, params, appId);
  return http.post_auth(apiPath, param);
};

// appId 写死 com.brightcns.h5      1、authCode换sessionId  2、获取手机号验证码  3、手机号登录
const POST_H5 = (method, params) => {
  let param = getGatewayParams_H5(method, params);
  return http.post(method, param);
};

//
const POST_PC = (method, params) => {
  let param = getGatewayParams_H5(method, params, "lzpc");
  return http.post(method, param);
};

// 带sessionId
const POST_H5_V10 = (method, params, apiPath) => {
  let param = getGatewayParams_H5_WITH_SESSION(method, params, null, "1.0");
  return http.post_auth(apiPath, param);
};

const POST_H5_V11 = (method, params, apiPath) => {
  let param = getGatewayParams_H5_WITH_SESSION(method, params, null, "1.1");
  return http.post_auth(apiPath, param);
};

const POST_GETINFO = (method, params) => {
  let param = getGatewayParams_H5(method, params, "com.brightcns.h5");
  return http.post(method, param);
};

// 通过小程序sessionId换取sessionId
export const loginS2S = (param, apiPath, appId) => {
  return POST_AUTH(API.loginS2S, param, apiPath, appId);
};

// 拿着s2s的sessionId去换authCode
export const getAuthCode = (param, apiPath, appId) => {
  return POST_AUTH_WITH_SESSION(API.getAuthCode, param, apiPath, appId);
};

// 通过authCode换取sessionId
export const getSessionId = (formData) => {
  return POST_H5(API.getSessionId, formData);
};

// 获取验证码
export const getCaptcha = (param) => {
  return POST_PC(API.getCaptcha, param);
};

// 手机号登录
export const SmsLogin = (param) => {
  return POST_H5(API.SmsLogin, param);
};

// 获取当前用户会员信息
export const getUserVipInfo = (param) => {
  return POST(API.getUserVipInfo, param);
};

// 退出登录
export const logout = (param) => {
  return POST(API.logout, param);
};
// 获取历史会话列表
export const getHistoryMessageList = (param) => {
  return POST(API.getHistoryMessageList, param);
};

// 获取历史会话详情
export const getHistoryMessageDetail = (param) => {
  return POST(API.getHistoryMessageDetail, param);
};

// 获取开场白
export const getPrologue = (param) => {
  return POST(API.getPrologue, param);
};

// 停止响应
export const stopGenerating = (param) => {
  return POST(API.stopGenerating, param);
};

// 删除对话
export const deleteMessage = (param) => {
  return POST(API.deleteMessage, param);
};

// 语音转文字
export const audioToText = (formData) => {
  return POST2(API.audioToText, formData);
};

// 文字转语音
export const TextToAudio = (formData) => {
  return POST2(API.TextToAudio, formData);
};

// 会话顶置  取消顶置
export const conversationSetTop = (formData) => {
  return POST(API.conversationSetTop, formData);
};

// 修改会话名称
export const conversationRename = (formData) => {
  return POST(API.conversationRename, formData);
};

// 发现列表
export const getFindList = (formData) => {
  return POST(API.getFindList, formData);
};

// 获取问题建议
export const getSuggested = (formData) => {
  return POST(API.getSuggested, formData);
};

// 获取今日会话次数
export const getConversationCount = (formData) => {
  return POST(API.getConversationCount, formData);
};

// 清除上下文
export const cleanConversationText = (formData) => {
  return POST(API.cleanConversationText, formData);
};

// 添加智能体
export const addAgent = (formData) => {
  return POST(API.addAgent, formData);
};

// 删除智能体
export const deleteAgent = (formData) => {
  return POST(API.deleteAgent, formData);
};

// 获取会话名称
export const getConversationName = (formData) => {
  return POST(API.getConversationName, formData);
};

// 查询新对话是否配置
export const getNewChat = (formData) => {
  return POST(API.getNewChat, formData);
};

// 智能体信息查询
export const getAgentInfo = (formData) => {
  return POST_GETINFO(API.getAgentInfo, formData);
};

// 通过ai_app_code查找会话
export const findConversation = (param) => {
  return POST(API.findConversation, param);
};

//文件上传
export const uploadFile = (param) => {
  return POST(API.uploadFile, param);
};

// 柳州拉码
export const getQrCode_LIUZHOU = (param, apiPath) => {
  console.log(param, apiPath);
  return POST_H5_V10(API.getQrCode, param, apiPath);
};

// 南通拉码
export const getQrCode_NANTONG = (param, apiPath) => {
  return POST_H5_V11(API.getQrCode, param, apiPath);
};

// 打开关闭自动播放
export const switchAutoTTS = (formData) => {
  return POST(API.switchAutoTTS, formData);
};

// 查询tts token数量
export const getTTSLimit = (formData) => {
  return POST(API.getTTSLimit, formData);
};

// 播放语音(自动)
export const autoTextToAudio = (formData) => {
  return POST2(API.autoTextToAudio, formData);
};

// 查询会话是否开启了自动播放
export const getAutoTTSInfo = (formData) => {
  return POST(API.getAutoTTSInfo, formData);
};

//举报类型
export const complaintTypes = (formData) => {
  return POST(API.complaintTypes, formData);
};

//新增举报
export const complaintAdd = (formData) => {
  return POST(API.complaintAdd, formData);
};

// 对话列表 查询AI引导
export const getGuides = (formData) => {
  return POST(API.getGuides, formData);
};

// 会话详情  获取当前会话额度&inputs参数
export const getChatDetail = (formData) => {
  return POST(API.getChatDetail, formData);
};

// 游客登录
export const guestLogin = (formData) => {
  return POST(API.guestLogin, formData);
};

// 查询是否启用了游客模式
export const getSystemInfo = (formData) => {
  return POST(API.getSystemInfo, formData);
};

// 判断当前游客和登录用户是否可以合并
export const isMergeable = (formData) => {
  return POST(API.isMergeable, formData);
};

// 合并游客用户
export const mergeGuest = (formData) => {
  return POST(API.mergeGuest, formData);
};
